<template>
  <div class='app'>
    <FullCalendar
      class='calendar'
      ref="fullCalendar"
      defaultView="dayGridMonth"
      :header="{
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay'
      }"
      :plugins="calendarPlugins"
      :weekends="calendarWeekends"
      :events="calendarEvents"
      />
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import firebase from 'firebase';

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  data() {
    return {
      calendarPlugins: [ // plugins must be defined in the JS
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin, // needed for dateClick
      ],
      calendarWeekends: true,
      calendarEvents: [],
    };
  },
  mounted() {
    const database = firebase.firestore();
    database.collection('calendars').doc(this.$route.params.calendar).collection('events').get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const event = doc.data();
          if (event.approved) {
            this.calendarEvents.push(
              {
                title: event.title,
                start: event.start.toDate(),
                end: event.end.toDate(),
                url: `#${this.$router.currentRoute.path}/${doc.id}`,
              },
            );
          }
        });
      });

    console.log(this.calendarEvents);
  },
  methods: {

  },
};

</script>

<style lang='scss'>

// you must include each plugins' css
// paths prefixed with ~ signify node_modules
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/timegrid/main.css';

</style>
